function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.67 5H9.33a1 1 0 00-.83.43L.17 17.04a.9.9 0 00.05 1.13l23 26.9c.4.46 1.16.46 1.55 0l23-26.9a.9.9 0 00.06-1.13L39.51 5.43c-.2-.27-.5-.43-.84-.43zm-1.61 3.79l5.27 7.58h-5.7l-4.3-7.58h4.73zm-9.29 0h-7.55l-4.3 7.58h16.16l-4.3-7.58zm-16.83 0h4.73l-4.3 7.58h-5.7l5.27-7.58zm.7 11.36H7.36l9.97 12.63-5.69-12.63zm4.3 0h16.13L24 39.35l-8.07-19.2zm20.41 0l-5.68 12.63 9.96-12.63h-4.28z"
})));